module.exports = new __parcel__URL__("elf-title-talent-7.68626da8.gif").toString();